import { jsx as _jsx } from "react/jsx-runtime";
import { ContentWrapper } from './Content.style';
const Content = ({ children }) => (_jsx(ContentWrapper, { children: children }));
export default Content;
